import { render, staticRenderFns } from "./AdmissionList.vue?vue&type=template&id=0c9e5f3c&scoped=true&"
import script from "./AdmissionList.vue?vue&type=script&lang=js&"
export * from "./AdmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e5f3c",
  null
  
)

export default component.exports